import { createReducer, on } from '@ngrx/store';
import { OfferWithImage } from '@/model/offer-with-image';
import * as AdvisoryBoardOffersActions from './advisory-board-offers.actions';

export interface AdvisoryBoardOffersState {
  offers: OfferWithImage[];
  loading: boolean;
  error: string | null;
  categoryIds: string[];
}

export const initialState: AdvisoryBoardOffersState = {
  offers: [],
  loading: false,
  error: null,
  categoryIds: [],
};

export const advisoryBoardOffersReducer = createReducer(
  initialState,
  on(
    AdvisoryBoardOffersActions.loadAdvisoryBoardOffers,
    (state, { categoryIds }) => ({
      ...state,
      loading: true,
      error: null,
      categoryIds,
    }),
  ),
  on(
    AdvisoryBoardOffersActions.loadAdvisoryBoardOffersSuccess,
    (state, { offers }) => ({
      ...state,
      offers,
      loading: false,
      error: null,
    }),
  ),
  on(
    AdvisoryBoardOffersActions.loadAdvisoryBoardOffersFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),
  ),
  on(AdvisoryBoardOffersActions.clearAdvisoryBoardOffers, (state) => ({
    ...state,
    offers: [],
    loading: false,
    error: null,
    categoryIds: [],
  })),
);
